import axios from 'axios';
import { config } from '../../../../config';
import { getAuthorizationBearerHeader } from '../../../../utills/get-authorization-bearer-header';

export const getAttachmentsList = (profileId) => {
    return axios.get(config.endpoints.attachments.basePath(profileId), {
        headers: { ...getAuthorizationBearerHeader() },
    });
};
